export default __webpack_public_path__ + "static/ios-uk-eb48e2964f1c316d4b5543b3b896cd61.webp";